import CheckboxCell from "../../../../common/interactive/CheckboxCell";
import IconBox from "../../../../iconboxes/IconBox";
import { miscellaneous } from "../../../../../lib/misc";
import { attorneyLegalStatusOptions, attorneyStatusOptionsPayerTypes } from "../../../../../lib/systemData";
import { getAttyStatusFromId } from "../../../../../lib/labels";

export default function AttorneyDrawerSection({classes, drawerData = {}, goToCaseTabHandler}) {
    const row = drawerData ?? {}
    const attorneys = Array.isArray(row.attorneys) ? row.attorneys : []
    const managingAttorney = attorneys.find((a) => a.is_managing_attorney) || null
    const attorneysCount = row.attorneys_count ?? attorneys.length
    const reps = row.case_negotiation?.reps
    const resolvedCollectionRep = reps?.prefered_collection_rep || reps?.collection_rep

    return <div className={classes.block}>
        <div className={classes.block_header}>
            <h3>Attorney</h3>
            {attorneysCount >= 2 && <div className={classes.totals}>{attorneysCount}</div>}
            <button onClick={goToCaseTabHandler.bind(this, 0)}><i className='ti ti ti-arrow-up-right'></i></button>
        </div>
        {miscellaneous.isObject(managingAttorney) && <>
            <div className={classes.block_body}>

                <div className={classes.block_body_row}>
                    <div className={classes.label}>Attorney Payer Status</div>
                    <div className={classes.value}>
                        {attorneyStatusOptionsPayerTypes()?.find(item => item.value == managingAttorney?.payer_status_id)?.label}
                    </div>
                </div>
                <div className={classes.block_body_row}>
                    <div className={classes.label}>Attorney Status</div>
                    <div className={classes.value}>
                        {getAttyStatusFromId(managingAttorney?.status_id)}
                    </div>
                </div>
                <div className={classes.block_body_row}>
                    <div className={classes.label}>Attorney Legal Status</div>
                    <div className={classes.value}>
                        {attorneyLegalStatusOptions()?.find(item => item.value == managingAttorney?.legal_status_id)?.label}
                    </div>
                </div>
                <div className={classes.block_body_row}>
                    <div className={classes.label}>Case manager</div>
                    <div className={classes.value}>
                        {managingAttorney?.case_manager && <>

                            <div>{managingAttorney.case_manager.first_name} {managingAttorney.case_manager.last_name}</div>               
                            {managingAttorney.case_manager.contact_information && <IconBox type={'phone'} link={managingAttorney.case_manager.contact_information.phone} workq={true}>
                                <i className="ti ti-phone"></i>
                            </IconBox>}
                            
                        </>}
                        
                    </div>
                </div>                        
                <div className={classes.block_body_row}>
                    <div className={classes.label}>IHC Review</div>
                    <div className={classes.value}>
                        <CheckboxCell checked={managingAttorney?.has_ich} isDisabled={true}/>
                    </div>
                </div>
                <div className={classes.block_body_row}>
                    <div className={classes.label}>Attorney Collection Rep</div>
                    <div className={classes.value}>
                        {resolvedCollectionRep && <>

                            <div>{resolvedCollectionRep?.name}</div>                 
                            {resolvedCollectionRep?.phone && <IconBox type={'phone'} link={resolvedCollectionRep?.phone} workq={true}>
                                <i className="ti ti-phone"></i>
                            </IconBox>}
                        </>}
                    </div>
                </div>
                <div className={classes.block_body_row}>
                    <div className={classes.label}>Co-Managed</div>
                    <div className={classes.value}>
                        <CheckboxCell checked={managingAttorney?.co_managed} isDisabled={true}/>
                    </div>
                </div>
                <div className={classes.block_body_row}>
                    <div className={classes.label}>ProcoDocs Atty Case ID</div>
                    <div className={classes.value}>{managingAttorney?.case_number}</div>
                </div>
                {/* <div className={classes.block_body_row}>
                    <div className={classes.label}>ProcoDocs Atty Case Status</div>
                    <div className={classes.value}>{attorneyLegalStatusOptions().find(item => item.value == managingAttorney?.legal_status_id)?.label}</div>
                </div> */}
            </div>
        </>}

        {!miscellaneous.isObject(managingAttorney) && <div className={classes.block_body}>
            <div className={classes.block_body_row}>
                <div className={classes.label}>No Attorney on file</div>
            </div>
        </div>}
        
    </div>
}